import SteelCompass from 'services/SteelCompass';

class Post {
  create(parentId, body, files, callback) {
    files = files.map(file => {
      return `[file:${file.id}]`;
    });
    body = body + files.join('');
    SteelCompass.call('post', 'create', { parentId, body }, response => {
      if (callback) {
        callback(response);
      }
    });
  }

  delete(id, callback) {
    SteelCompass.call('post', 'delete', { id }, response => {
      if (callback) {
        callback(response);
      }
    });
  }

  follow(postId, callback) {
    SteelCompass.call('post', 'follow', { postId }, response => {
      if (callback) {
        callback(response);
      }
    });
  }

  unfollow(postId, callback) {
    SteelCompass.call('post', 'unfollow', { postId }, response => {
      if (callback) {
        callback(response);
      }
    });
  }

  update(parentId, body, files, callback) {
    files = files.map(file => {
      return `[file:${file.id}]`;
    });
    body = body + files.join('');
    SteelCompass.call('post', 'update', { id: parentId, body }, response => {
      if (callback) {
        callback(response);
      }
    });
  }
}

export default new Post();



// WEBPACK FOOTER //
// ./src/js/services/Post.js